import { DraggableContainerStateType } from '../../../../../../components/draggableContainer/types/draggableContainerStateType';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { CheckboxVariantType, DraggableContainerVariantType, IconButtonSizeType, IconButtonVariantType, SelectionIndicatorSizeType, SelectionIndicatorVariantType, TextVariantType, } from '../../variants';
const commonStateStyles = (FOUNDATIONS, styles) => {
    return {
        rootContainer: {
            width: '100%',
            border_radius: FOUNDATIONS.radius_comp_containers_draggablecontainer_radiussize,
            ...styles.rootContainer,
        },
        headerContainer: {
            width: '100%',
            display: 'flex',
            flex_direction: 'row',
            align_items: 'center',
            gap: FOUNDATIONS.spacing_250,
            background_color: FOUNDATIONS.color_comp_containers_draggablecontainer_unselected_header_bg,
            border_radius: FOUNDATIONS.radius_comp_containers_draggablecontainer_radiussize,
            border_style: 'solid',
            border_width: FOUNDATIONS.border_50,
            border_color: FOUNDATIONS.color_comp_containers_draggablecontainer_border,
            padding: FOUNDATIONS.spacing_250,
            ...styles.headerContainer,
        },
        headerContainerWithContent: {
            width: '100%',
            display: 'flex',
            flex_direction: 'row',
            align_items: 'center',
            gap: FOUNDATIONS.spacing_250,
            background_color: FOUNDATIONS.color_comp_containers_draggablecontainer_unselected_header_bg,
            border_radius: `${FOUNDATIONS.radius_comp_containers_draggablecontainer_radiussize} ${FOUNDATIONS.radius_comp_containers_draggablecontainer_radiussize} 0 0`,
            border_style: 'solid',
            border_bottom_style: 'none',
            border_width: FOUNDATIONS.border_50,
            border_color: FOUNDATIONS.color_comp_containers_draggablecontainer_border,
            padding: FOUNDATIONS.spacing_250,
            ...styles.headerContainerWithContent,
        },
        leftHeaderContainer: {
            flex_grow: '1',
            display: 'flex',
            flex_direction: 'row',
            align_items: 'center',
            gap: FOUNDATIONS.spacing_250,
            ...styles.leftHeaderContainer,
        },
        draggableIcon: {
            width: FOUNDATIONS.size_300,
            height: FOUNDATIONS.size_300,
            color: FOUNDATIONS.color_comp_containers_draggablecontainer_icon,
            ...styles.draggableIcon,
        },
        selectorsTextsContainer: {
            flex_grow: '1',
            display: 'flex',
            flex_direction: 'row',
            align_items: 'center',
            gap: FOUNDATIONS.spacing_250,
            position: 'relative',
            ...styles.selectorsTextsContainer,
        },
        selectionIndicator: {
            variant: SelectionIndicatorVariantType.DEFAULT,
            size: SelectionIndicatorSizeType.SMALL,
            ...styles.selectionIndicator,
        },
        checkbox: {
            variant: CheckboxVariantType.REGULAR,
            ...styles.checkbox,
        },
        icon: {
            width: FOUNDATIONS.size_350,
            height: FOUNDATIONS.size_350,
            color: FOUNDATIONS.color_neutral_icon_50,
            ...styles.icon,
        },
        textsContainer: {
            flex: 1,
            display: 'flex',
            flex_direction: 'row',
            align_items: 'center',
            gap: FOUNDATIONS.spacing_150,
            ...styles.textsContainer,
        },
        title: {
            font_variant: TextVariantType.FONT_PARAGRAPH_250,
            font_weight: FONT_WEIGHT.font_bold,
            color: FOUNDATIONS.color_neutral_font_50,
            display: '-webkit-box',
            overflow: 'hidden',
            webkit_line_clamp: '2',
            webkit_box_orient: 'vertical',
            ...styles.title,
        },
        counter: {
            font_variant: TextVariantType.FONT_PARAGRAPH_200,
            font_weight: FONT_WEIGHT.font_regular,
            color: FOUNDATIONS.color_neutral_font_50,
            ...styles.counter,
        },
        input: {
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            cursor: 'pointer',
            ...styles.input,
        },
        rightHeaderContainer: {
            display: 'flex',
            flex_direction: 'row',
            column_gap: FOUNDATIONS.spacing_150,
            ...styles.rightHeaderContainer,
        },
        firstChevronIcon: {
            width: FOUNDATIONS.size_300,
            height: FOUNDATIONS.size_300,
            color: FOUNDATIONS.color_comp_actions_iconbutton_secondary_default_icon,
            ...styles.firstChevronIcon,
            disabled: {
                width: FOUNDATIONS.size_300,
                height: FOUNDATIONS.size_300,
                color: FOUNDATIONS.color_accent_disabled_icon_100,
                ...styles.firstChevronIcon?.disabled,
            },
        },
        secondChevronIcon: {
            width: FOUNDATIONS.size_300,
            height: FOUNDATIONS.size_300,
            color: FOUNDATIONS.color_comp_actions_iconbutton_secondary_default_icon,
            ...styles.secondChevronIcon,
            disabled: {
                width: FOUNDATIONS.size_300,
                height: FOUNDATIONS.size_300,
                color: FOUNDATIONS.color_accent_disabled_icon_100,
                ...styles.secondChevronIcon?.disabled,
            },
        },
        firstChevronIconButton: {
            variant: IconButtonVariantType.SECONDARY,
            size: IconButtonSizeType.SMALL,
            ...styles.firstChevronIconButton,
        },
        secondChevronIconButton: {
            variant: IconButtonVariantType.SECONDARY,
            size: IconButtonSizeType.SMALL,
            ...styles.firstChevronIconButton,
        },
        contentContainer: {
            width: '100%',
            border_radius: `0 0 ${FOUNDATIONS.radius_comp_containers_draggablecontainer_radiussize} ${FOUNDATIONS.radius_comp_containers_draggablecontainer_radiussize}`,
            border_style: 'solid',
            border_top_style: 'none',
            border_width: FOUNDATIONS.border_50,
            border_color: FOUNDATIONS.color_comp_containers_draggablecontainer_border,
            padding: `0 ${FOUNDATIONS.spacing_250}`,
            background_color: FOUNDATIONS.color_comp_containers_bg,
            ...styles.contentContainer,
        },
    };
};
export const getDefaultStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [DraggableContainerVariantType.DEFAULT]: {
            [DraggableContainerStateType.DEFAULT_UNSELECTED]: commonStateStyles(FOUNDATIONS, {
                headerContainer: {
                    background_color: FOUNDATIONS.color_comp_containers_draggablecontainer_unselected_header_bg,
                },
                headerContainerWithContent: {
                    background_color: FOUNDATIONS.color_comp_containers_draggablecontainer_unselected_header_bg,
                },
            }),
            [DraggableContainerStateType.DEFAULT_SELECTED]: commonStateStyles(FOUNDATIONS, {
                headerContainer: {
                    background_color: FOUNDATIONS.color_comp_containers_draggablecontainer_selected_header_bg,
                },
                headerContainerWithContent: {
                    background_color: FOUNDATIONS.color_comp_containers_draggablecontainer_selected_header_bg,
                },
            }),
            [DraggableContainerStateType.DISABLED_SELECTED]: commonStateStyles(FOUNDATIONS, {
                headerContainer: {
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                },
                headerContainerWithContent: {
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                },
                rootContainer: {
                    pointer_events: 'none',
                },
            }),
            [DraggableContainerStateType.DISABLED_UNSELECTED]: commonStateStyles(FOUNDATIONS, {
                headerContainer: {
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                },
                headerContainerWithContent: {
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                },
                title: {
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
                counter: {
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
                draggableIcon: {
                    color: FOUNDATIONS.color_accent_disabled_icon_100,
                },
                icon: {
                    color: FOUNDATIONS.color_accent_disabled_icon_100,
                },
                rootContainer: {
                    pointer_events: 'none',
                },
            }),
        },
    };
};
//# sourceMappingURL=default.js.map